import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  state: string;
  manual: number;
};

const MeasureLogStatusManualDev: React.FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  let label = '';
  switch (props.state) {
    case '1':
      switch (props.manual) {
        case 1:
          label = t('MeasureLogStatusManualDev.OK(手動)', 'OK(手動)');
          break;
        default:
          label = 'OK';
      }
      break;
    default:
      label = `NG${props.state}`;
  }

  return <div>{label}</div>;
};

export default MeasureLogStatusManualDev;
